import { tJosa } from '@mathflat/shared/i18n/tJosa'

import { RouteName } from './RouteName'

export const ROUTE_RESTRICTION_MESSAGE_MAP: Partial<
  Record<ValueOf<typeof RouteName>, () => string>
> = {
  [RouteName.academyGroupShareScopeWorksheet]: () =>
    `${tJosa('학원그룹 공유 학습지', '은/는')} 마스터/매니저만 접근할 수 있습니다.`,
  [RouteName.academyGroupShareScopeWorkbook]: () =>
    `${tJosa('학원그룹 공유 교재', '은/는')} 마스터/매니저만 접근할 수 있습니다.`,
  [RouteName.entranceTest]: () =>
    `${tJosa('입학고사', '은/는')} 마스터/매니저만 사용할 수 있습니다.`,
}
